import {
  getStudentDepartments,
  getInternDepartments,
  getStudent,
  putStudent,
  getStudentEnterpriseVisitEnrollments,
  putStudentEnterpriseVisitEnrollment,
  getStudentCareerCounsellingEnrollments,
  getStudentCareerLectureEnrollments,
  putStudentCareerLectureEnrollment,
  postStudentEnrollLecture,
  getStudentCareerLectureEnrollmentsById,
  postStudentEnrollVisit,
  postStudentEnrollCareerCounselling,
  putStudentCareerCounsellingEnrollment,
  getLineCategory,
  getLineSetting,
  getInternSearchOptions,
  getInternRecordList,
  getEnterprisesList,
  sendInternForm,
  getInternForm,
  getFileNameList,
  deleteInternFile,
  uploadInternFormFile,
  downloadInternFormFile,
  getStudentReminder,
} from '~api/students'

export const state = () => ({
  departments: [],
  departmentOfs: [],
  currentStudent: {},
  enterpriseVisitEnrolledRecords: [],
  careerCounsellingEnrolledRecords: [],
  careerLectureEnrolledRecords: [],
  pages: {},
  degree: {
    'B': '大學',
    'M': '研究所',
    'D': '博士班'
  },
  currentStudentLectureEnrollment: {},
  lineCategory:{},
  lineSetting:{},
  currentInternSearchOptions: [],
  currentInternRecordList: [],
  currentInternEnterpriseList: [],
  currentInternForm: {},
  currentStudentReminder: [],
  currentFileNameList: [],
})

export const getters = {
  departmentsGetter: state => state.departments,
  departmentOfsGetter: state => state.departmentOfs,
  currentStudentGetter: state => state.currentStudent,
  pageGetter: state => state.pages,
  enterpriseVisitEnrolledRecordsGetter: state => state.enterpriseVisitEnrolledRecords,
  careerCounsellingEnrolledRecordsGetter: state => state.careerCounsellingEnrolledRecords,
  careerLectureEnrolledRecordsGetter: state => state.careerLectureEnrolledRecords,
  getStudentDepartmentById: state => (id) => state.departments.find((dept) => dept.department_id === id),
  getAcademicDegreeByCode: state => (code) => state.degree[code],
  currentStudentLectureEnrollmentGetter: state => state.currentStudentLectureEnrollment,
  isEnrolledCurrentEnterpriseVisitGetter: state => (visitId) => state.enterpriseVisitEnrolledRecords.findIndex(visit => visit.visit_id === visitId) > -1,
  isEnrolledCurrentCareerLectureGetter: state => (lectureId) => state.careerLectureEnrolledRecords.findIndex(lecture => lecture.lecture_id === lectureId) > -1,
  currentLineCategoryGetter: state =>  state.lineCategory,
  currentLineSettingGetter: state =>  state.lineSetting,
  currentInternSearchOptionsGetter: state => state.currentInternSearchOptions,
  currentInternRecordListGetter: state =>  state.currentInternRecordList,
  currentInternEnterpriseListGetter: state =>  state.currentInternEnterpriseList,
  currentInternFormGetter: state => state.currentInternForm,
  currentStudentReminderGetter: state => state.currentStudentReminder,
  currentFileNameListGetter: state => state.currentFileNameList,
}

export const actions = {
  async getDepartments ({ commit, getters }, degree) {
    if (getters.departmentsGetter.length) {
      return getters.departmentsGetter
    }
    const data = await getStudentDepartments(degree)
    commit('setDepartments', data)
    return data
  },
  async getDepartmentOfs ({ commit, getters }) {
    if (getters.departmentOfsGetter.length) {
      return getters.departmentOfsGetter
    }
    const data = await getInternDepartments()
    commit('setDepartmentOfs', data)
    return data
  },
  async getStudentByToken ({ commit, dispatch }) {
    try {
      const data = await getStudent()
      commit('setCurrentStudent', data)
      return data
    } catch (err) {
	console.log(err);	
      dispatch('auth/userLogout', 'student', { root: true })
    }
  },
  async updateStudentProfile ({ commit }, profile) {
    const response = await putStudent(profile)
    return response
  },
  logout ({ commit }) {
    commit('resetCurrentStudent')
  },
  async getEnterpriseVisitEnrolledRecords ({ commit }, type, data) {
    const response = await getStudentEnterpriseVisitEnrollments(data)
    const {
      enrollments,
      pages
    } = response
    commit('setEnterpriseVisitEnrolledRecords', enrollments)
    commit('setRecordsPage', pages)
    return response
  },
  async cancelEnrolledEnterpriseVisitById ({ commit }, enrollmentId) {
    const response = await putStudentEnterpriseVisitEnrollment(enrollmentId)
    return response
  },
  async cancelEnrolledCareerLectureById ({ commit }, enrollmentId) {
    const response = await putStudentCareerLectureEnrollment(enrollmentId)
    return response
  },
  async cancelEnrolledCareerCounsellingByTypeNId ({ commit }, typeNId) {
    const response = await putStudentCareerCounsellingEnrollment(typeNId)
    return response
  },
  async getCareerCounsellingEnrolledRecordsByType ({ commit }, { type, params }) {
    const response = await getStudentCareerCounsellingEnrollments(type, params)
    const {
      enrollments,
      pages
    } = response
    commit('setCareerCounsellingEnrolledRecords', enrollments)
    commit('setRecordsPage', pages)
    return response
  },
  async getCareerLectureEnrolledRecords ({ commit }, params) {
    const response = await getStudentCareerLectureEnrollments(params)
    const {
      enrollments,
      pages
    } = response
    commit('setCareerLectureEnrolledRecords', enrollments)
    commit('setRecordsPage', pages)
    return response
  },
  async createStudentCareerLectureEnrollment ({}, enrollment) {
    const response = await postStudentEnrollLecture(enrollment)
    return response
  },
  async getCareerLectureEnrollmentById ({ commit }, id) {
    const enrollment = await getStudentCareerLectureEnrollmentsById(id)

    commit('setCurrentStudentLectureEnrollment', enrollment)
    return enrollment
  },
  async createStudentEnterpriseVisitEnrollment ({}, enrollment) {
    const response = await postStudentEnrollVisit(enrollment)
    return response
  },
  async createStudentCareerCounsellingEnrollment ({}, enrollment) {
    const response = await postStudentEnrollCareerCounselling(enrollment)
    return response
  },
  async getCurrentLineCategory({ commit }){
    const response = await getLineCategory()
    commit('setCurrentLineCategory',response)
    return response
  },
  async getCurrentLineSetting({ commit }){
    const response = await getLineSetting()
    commit('setCurrentLineSetting',response)
    return response
  },
  async getInternSearchOptions ({ commit }) {
    const response = await getInternSearchOptions();
    const {
      internSearchOptions
    } = response
    commit('setInternSearchOptions', internSearchOptions)
    return response
  },
  async getInternRecordList ({ commit }, params) {
    const response = await getInternRecordList(params);
    const {
      internRecordList
    } = response
    commit('setInternRecordList', internRecordList)
    return response
  },
  async getEnterprisesList({ commit }, keyword){
    const response = await getEnterprisesList(keyword)
    const {
      internEnterpriseList,
    } = response;
    commit('setCurrentInternEnterpriseList', internEnterpriseList)
    return response
  },
  async sendInternForm ({ commit }, params) {
    const response = await sendInternForm(params);
    return response
  },
  async getInternForm ({ commit }, params) {
    const response = await getInternForm(params);
    const {
      formData
    } = response
    commit('setInternForm', formData)
    return response
  },
  async getFileNameList ({ commit }, params) {
    commit('setFileNameList', [])
    const response = await getFileNameList(params);
    const {
      fileNameList,
    } = response
    commit('setFileNameList', fileNameList)
    return response
  },
  async deleteInternFile ({ commit }, params) {
    const response = await deleteInternFile(params);
    return response
  },
  async uploadInternFormFile ({ commit }, params) {
    const response = await uploadInternFormFile(params);
    return response
  },
  async downloadInternFormFile ({ commit }, params) {
    const response = await downloadInternFormFile(params);
    return response
  },
  async getStudentReminder ({ commit }) {
    const response = await getStudentReminder();
    commit('setStudentReminder', response);
    return response
  },
}

export const mutations = {
  setDepartments (state, payload) {
    state.departments = payload
  },
  setDepartmentOfs (state, payload) {
    state.departmentOfs = payload
  },
  setCurrentStudent (state, payload) {
    state.currentStudent = payload
  },
  resetCurrentStudent (state, payload) {
    state.currentStudent = {}
  },
  setEnterpriseVisitEnrolledRecords (state, payload) {
    state.enterpriseVisitEnrolledRecords = payload
  },
  setCareerCounsellingEnrolledRecords (state, payload) {
    state.careerCounsellingEnrolledRecords = payload
  },
  setRecordsPage (state, payload) {
    state.pages = payload
  },
  setCareerLectureEnrolledRecords (state, payload) {
    state.careerLectureEnrolledRecords = payload
  },
  setCurrentStudentLectureEnrollment (state, payload) {
    state.currentStudentLectureEnrollment = payload
  },
  setCurrentLineCategory(state,payload){
    state.lineCategory =  payload
  },
  setCurrentLineSetting(state,payload){
    state.lineSetting = payload
  },
  setInternSearchOptions (state, payload) {
    state.currentInternSearchOptions = Object.assign({}, payload);
  },
  setInternRecordList(state,payload){
    state.currentInternRecordList = payload
  },
  setCurrentInternEnterpriseList(state,payload){
    state.currentInternEnterpriseList = payload
  },
  setInternForm (state, payload) {
    state.currentInternForm = Object.assign({}, payload)
  },
  setStudentReminder (state, payload) {
    state.currentStudentReminder = payload;
  },
  setFileNameList (state, payload) {
    state.currentFileNameList = payload;
  },
}
